import { Injectable } from '@angular/core';

interface GoogleRecaptcha {
  render: (...args: any[]) => any;
}

declare const grecaptcha: GoogleRecaptcha;

@Injectable({
  providedIn: 'root',
})
export class GoogleRecaptchaLoaderService {
  private loadingPromise?: Promise<void>;

  load(): Promise<void> {
    // Already loaded
    if (this.isRecaptchaLoaded()) {
      return Promise.resolve();
    }

    // Already loading
    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise<void>((resolve, reject) => {
      // Check if script already exists
      const existingScript = document.querySelector(
        'script[src*="recaptcha/api.js"]'
      );

      if (existingScript) {
        this.waitForRecaptcha(resolve);
        return;
      }

      // Create script
      const script = document.createElement('script');

      script.src = 'https://www.google.com/recaptcha/api.js?render=explicit';
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.waitForRecaptcha(resolve);
      };

      script.onerror = () => {
        reject(new Error('Unable to load Google reCAPTCHA'));
      };

      document.head.appendChild(script);
    });

    return this.loadingPromise;
  }

  private isRecaptchaLoaded(): boolean {
    return (
      typeof grecaptcha !== 'undefined' &&
      typeof grecaptcha.render === 'function'
    );
  }

  private waitForRecaptcha(resolve: () => void): void {
    const check = (): void => {
      if (this.isRecaptchaLoaded()) {
        resolve();
      } else {
        window.setTimeout(check, 100);
      }
    };

    check();
  }
}
